import TYPES from './types';
import { put, post } from 'utils/api';
import { successHandler } from 'common/utils/notifications';
import { updateTableRow, resetTableRowUpdate } from 'store/tables/lists/actions';
import TABLE_TYPES from 'common/components/table/store/types';

export const clearTableMapPorts = params => (dispatch, getState) => {
  const { table } = params;

  dispatch({
    type: TABLE_TYPES.GET_TABLE_LIST.SUCCESS,
    payload: {
      params,
      table,
      data: []
    }
  });
};

export const updatePort = params => dispatch => {
  const { id, table, ...rest } = params;

  dispatch({ type: TYPES.UPDATE_PORT.START, payload: params });

  return put(`/ports/${id}`, { ...rest })
    .then(response => {
      dispatch({ type: TYPES.UPDATE_PORT.SUCCESS, payload: response.data });
      dispatch(updateTableRow({ data: response.data.data, table }));
      dispatch(successHandler({ title: 'Success!', message: 'Updated successfully' }));
      return response.data;
    })
    .catch(error => {
      dispatch({ type: TYPES.UPDATE_PORT.ERROR, payload: { response: error, params } });
      dispatch(resetTableRowUpdate({ data: params, table }));
      return error;
    });
};

export const createPort = params => dispatch => {
  const { table, ...rest } = params;

  dispatch({ type: TYPES.CREATE_PORT.START, payload: params });

  return post(`/ports`, { ...rest })
    .then(response => {
      dispatch({ type: TYPES.CREATE_PORT.SUCCESS, payload: response.data });
      dispatch(successHandler({ title: 'Success!', message: 'Created successfully' }));
      return response.data;
    })
    .catch(error => {
      dispatch({ type: TYPES.CREATE_PORT.ERROR, payload: { response: error, params } });
      dispatch(resetTableRowUpdate({ data: params, table }));
      return error;
    });
};

export const archivePort = params => dispatch => {
  dispatch({ type: TYPES.ARCHIVE_PORT.START, payload: { params } });

  return put(`/ports/${params.id}/archive`)
    .then(response => {
      dispatch({ type: TYPES.ARCHIVE_PORT.SUCCESS, payload: response.data });

      return response.data;
    })
    .catch(error => dispatch({ type: TYPES.ARCHIVE_PORT.ERROR, payload: error }));
};

export const unArchivePort = params => dispatch => {
  dispatch({ type: TYPES.UNARCHIVE_PORT.START, payload: { params } });

  return put(`/ports/${params.id}/unarchive`)
    .then(response => {
      dispatch({ type: TYPES.UNARCHIVE_PORT.SUCCESS, payload: response.data });

      return response.data;
    })
    .catch(error => dispatch({ type: TYPES.UNARCHIVE_PORT.ERROR, payload: error }));
};
